
import plansMixins from '@/mixins/plans'

export default {
  name: 'Plans',
  mixins: [plansMixins],
  props: {
    availablePlans: {
      type: Array,
      required: true,
    },
    billingPeriod: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  methods: {
    formatNumber(value) {
      if (value === -1) {
        return ''
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
